angular.module("leanlaw.core").factory("matterManager", ["$q", '$timeout', "leanLawApi", 'userService', 'accountingService', 'lists', 'onboardService', 'clientMatterManager', function ($q, $timeout, leanLawApi, userService, accountingService, lists, onboardService, clientMatterManager) {
  var _service = {
    create: createMatter,
    get: getMatter,
    overview,
    list: listMatters,
    listForClient: listClientMatters,
    roles: lists.matterRoles,
    listClientsFromMatters
  };

  /////////////////////////////////

  function getMatter(id) {
    return clientMatterManager.getMatter(id);
  }
  function listMatters(options) {
    return clientMatterManager.listMatters(options);
  }
  function listClientMatters(clientId, options) {
    return clientMatterManager.listMattersForClient(clientId, options);
  }
  function listClientsFromMatters(matters, options) {
    return clientMatterManager.listClientsForMatters(matters, options);
  }
  function createMatter(matter) {
    return clientMatterManager.createMatter(matter);
  }
  function overview() {
    return leanLawApi.getMatterOverview();
  }
  return _service;
}]);